import React from 'react';
import HelpApiLayout from '../../../../components/layout/HelpApiLayout';
import HelpSidebar from '../../../../components/layout/HelpSidebar';
import ArticleViewer from '../../components/ArticleViewer';
import { PUBLIC_ROUTES } from '../../../../constants/routes';
import '../getting-started/HelpCategoryPage.css';

/**
 * Managing Your Profile Article Page
 */
const Profile = () => {
  return (
    <HelpApiLayout type="help" sidebar={<HelpSidebar />}>
      <div className="help-category-page">
        <div className="help-category-container">
          <main className="help-category-main">
            <ArticleViewer 
              title="Managing Your Profile"
              showQA={true}
              articleId="profile"
            >
              <div className="article-content">
                <p>
                  Keep your profile up to date to help friends find you and personalize your
                  WeSplit experience.
                </p>
                
                <h2>Updating Profile Information</h2>
                <p>To edit your profile:</p>
                <ol>
                  <li>Go to Settings → Profile</li>
                  <li>Tap on any field you want to update</li>
                  <li>Make your changes</li>
                  <li>Tap "Save" to confirm</li>
                </ol>

                <h2>Profile Picture</h2>
                <p>
                  Add or change your profile picture by tapping the camera icon on your profile.
                  You can upload from your photo library or take a new photo.
                </p>

                <h2>Username</h2>
                <p>
                  Your username is how others find you on WeSplit. Choose something unique and
                  memorable. You can change it anytime, but it must be available.
                </p>

                <h2>Bio and Details</h2>
                <p>
                  Add a bio to tell others about yourself. You can also add your location or
                  other details that help friends recognize you.
                </p>

                <h2>Verification</h2>
                <p>
                  Verify your email and phone number to increase account security and help others
                  trust your profile.
                </p>
              </div>
            </ArticleViewer>
          </main>
        </div>
      </div>
    </HelpApiLayout>
  );
};

export default Profile;
